import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { dismissHomeBootSplash } from './lib/bootSplash'
import { initTheme } from './theme'

initTheme()
dismissHomeBootSplash()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
